import React, { useEffect } from "react";
import { Box, Alert } from "@mui/material";
import { MutatingDots } from "react-loader-spinner";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getPhotoAlbum } from "./store/slices/photoAlbum";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
import { orderBy } from "lodash-es";
import PoweredBy from "./component/PoweredBy";
import WidgetTitle from "./component/WidgetTitle";

const PhotoAlbumWidget = ({
	language,
	photoAlbumID,
	eventID,
	organiserID,
	color,
	displayTitle,
	headerTitle,
	rowHeight,
}) => {
	const dispatch = useDispatch();
	const [index, setIndex] = React.useState(-1);
	const [slides, setSlides] = React.useState([]);

	const { error, loading, photoAlbum } = useSelector(
		(state) => state.photoAlbum
	);

	useEffect(() => {
		dispatch(
			getPhotoAlbum({
				organiserID: organiserID,
				eventID: eventID,
				id: photoAlbumID,
				language: language,
			})
		);
	}, [eventID, organiserID, language, dispatch, photoAlbumID]);

	const getMeta = (url, cb) => {
		const img = new Image();
		img.onload = () => cb(null, img);
		img.onerror = (err) => cb(err);
		img.src = url;
	};

	React.useEffect(() => {
		setSlides([]);
		photoAlbum?.photos.map(async (p) => {
			const src = p.imgPath;
			getMeta(src, (_err, img) => {
				const { naturalWidth: width, naturalHeight: height } = img;
				const slide = {
					src,
					width,
					height,
					positionIndex: p.positionIndex,
				};
				setSlides((prev) =>
					orderBy([...prev, slide], ["positionIndex"], ["asc"])
				);
			});
		});
	}, [photoAlbum?.photos]);

	if (loading) {
		return (
			<Box className="widget-spinner">
				<MutatingDots
					visible={true}
					height="100"
					width="100"
					color="#4fa94d"
					secondaryColor="#4fa94d"
					radius="12.5"
					ariaLabel="mutating-dots-loading"
					wrapperStyle={{}}
					wrapperClass=""
				/>
			</Box>
		);
	}

	if (error) return <></>;

	return (
		<>
			{!photoAlbum ? (
				<Box className="widget-block--search-not">
					<Alert severity="info">
						<FormattedMessage id="photoAlbumNotFound" />
					</Alert>
				</Box>
			) : (
				<div className="widget-block" style={{ "--color": color }}>
					{displayTitle && (
						<WidgetTitle title={headerTitle}>{photoAlbum.title}</WidgetTitle>
					)}
					<Box className="widget-block--program">
						<RowsPhotoAlbum
							photos={slides}
							targetRowHeight={rowHeight}
							componentsProps={{
								image: () => ({
									className:
										"widget-block--sponsors--cat--logo widget-block--p-0",
								}),
							}}
							onClick={({ index: current }) => setIndex(current)}
						/>
					</Box>

					<Lightbox
						index={index}
						slides={slides}
						open={index >= 0}
						close={() => setIndex(-1)}
					/>
					<PoweredBy />
				</div>
			)}
		</>
	);
};

export default PhotoAlbumWidget;
